// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__y3Ec3","right":"Footer_right__2dm2g","buttons":"Footer_buttons__1hEns"};